import { LogType } from './LogType';
import { bUlsCache } from './bUlsCache';
import { TraceLevel } from './TraceLevel';
export function getUlsLogger(userSessionId, remoteUlsEndpoint) {
    var cache = new bUlsCache(userSessionId, remoteUlsEndpoint);
    return {
        sendTraceTag: function (tag, category, level, message) {
            return traceTagImpl(cache, tag, category, level, message);
        },
        shipAssertTag: function (tag, category, condition, message) {
            if (condition) {
                traceTagImpl(cache, tag, category, TraceLevel.Error, message);
            }
        },
        debugAssertTag: function () {
            // We don't yet have support for debug asserts. To do this properly, we want to write a TypeScript or Babel
            // plugin that does this transformation debugAssertTag(args) into node.env.production !== "production" && debugAssertTag(args)
            // to ensure that expensive conditionals are not evaluated in ship code.
            throw new Error('Debug Asserts not Implemented in the TypeScript bULS module');
        },
        flush: cache.flush,
        flushOnClose: cache.flushOnClose
    };
}
/** log Verbose and above in debug, Info and above in Ship */
var currentLevel = process.env.NODE_ENV !== 'production' ? TraceLevel.Verbose : TraceLevel.Info;
function traceTagImpl(cache, tag, category, level, message) {
    // check if the log statement is important enough to be logged
    if (level > currentLevel)
        return;
    var args = {
        timestamp: Date.now(),
        category: category,
        tag: tag,
        level: level,
        type: LogType.Trace,
        message: message
    };
    cache.handleTrace(args);
}
//# sourceMappingURL=bUls.js.map